export const BET_ACTION_MODAL_TYPE = {
  statistics: 1,
  favoriteBets: 2,
  reBet: 3,
}